import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import type { Track } from '../useAudioPlayer';
import './retro.css';

type LocationState = {
  url: string;
  contextName: string;
  backPath: string;
  gameMode: string;
  backgroundImage: string;
  artistId: string;
  poolSize: number;
};

export default function LoadingView() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { url, contextName, backPath, gameMode, backgroundImage, artistId, poolSize } = state as LocationState;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error('Failed to fetch tracks');
        const tracks: Track[] = await res.json();
        if (tracks.length === 0) {
          navigate(backPath, { state: { error: 'No tracks found. Try another.' } });
          return;
        }
        navigate(`/player/${gameMode}`, { 
          state: { 
            tracks, 
            contextName, 
            backPath, 
            backgroundImage,
            artistId,
            poolSize
          } 
        });
      } catch {
        navigate(backPath, { state: { error: 'Could not load tracks. Try again.' } });
      }
    };

    load();
  }, [artistId, backPath, backgroundImage, contextName, gameMode, navigate, url, poolSize]);

  return (
    <div className="landing-root">
      <div className="grain" />
      <div className="vignette" />
      <div className="loading-inner">
        <div className="loading-reels">
          <div className="reel reel-spin">
            <div className="reel-hub" />
          </div>
          <div className="tape-bridge" />
          <div className="reel reel-spin reel-spin-reverse">
            <div className="reel-hub" />
          </div>
        </div>
        <div className="loading-text">LOADING {contextName.toUpperCase()}</div>
        <div className="loading-dots">
          <span>·</span><span>·</span><span>·</span>
        </div>
      </div>
    </div>
  );
}